import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import classNames from 'classnames';

import './index.less';
import useClickOutside from '../../../../hooks/useClickOutside';

const ModalOuterFrame = (props) => {
  const {
    className,
    children,
    onDismiss,
    hasDarkBackground = false,
    labelledByRef,
  } = props;

  const modalRef = useRef(undefined);
  const onClickedOutside = () => onDismiss();

  useClickOutside(modalRef, onClickedOutside);

  useEffect(() => {
    if (modalRef.current) {
      modalRef.current.focus();
    }
  }, []);

  const labelledBy = labelledByRef.current ? labelledByRef.current.id : null;

  return <div className={classNames('backdrop', { 'backdrop--dark': hasDarkBackground })}>
    <div
      ref={modalRef}
      tabIndex={-1}
      className={classNames('lightbox', className)}
      role="dialog"
      aria-labelledby={labelledBy}
      // aria-modal="true"
    >{children}</div>
  </div>;
};

const GenericModal = (props) => {
  const {
    className = '',
    children,
    title,
    subtitle = false,
    hasDarkBackdrop = false,
    disablePadding = false,
    hideTitle = false,
    onDismiss = () => null,
  } = props;

  const [headerUuid] = useState(uuid());
  const labelledByHeader = useRef(undefined);

  return <ModalOuterFrame
    hasDarkBackground={hasDarkBackdrop}
    className={classNames('genericmodal', { 'genericmodal--nopadding': disablePadding }, className)}
    onDismiss={onDismiss}
    labelledByRef={labelledByHeader}
  >
    <header className={classNames('genericmodal__header', { 'genericmodal__header--hidden-title': hideTitle })}>

      <h2 id={headerUuid} ref={labelledByHeader}>{title}</h2>
      {subtitle || ''}
    </header>
    <div className="genericmodal__body">{children}</div>
  </ModalOuterFrame>;
};
// <a href={"selger/" + sellerid}>Sjekk selgerens andre annonser</a>
GenericModal.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  onDismiss: PropTypes.func,
  hideTitle: PropTypes.bool,
  disablePadding: PropTypes.bool,
  hasDarkBackdrop: PropTypes.bool,
};

export default GenericModal;
